import { MapPin } from "lucide-react";

// OpenStreetMap embed with a pin at the property's geotagged location (no API key needed)
export function PropertyMap({ lat, lng, height = 220 }) {
  if (lat == null || lng == null) {
    return (
      <div
        className="flex items-center justify-center rounded-md border border-dashed border-slate-300 bg-slate-50 text-center text-xs font-medium text-slate-400"
        style={{ height }}
        data-testid="property-map-empty"
      >
        Take the geotagged front-of-dwelling photo to pin the property on the map.
      </div>
    );
  }
  const d = 0.0035;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  return (
    <div className="overflow-hidden rounded-md border border-slate-200" data-testid="property-map">
      <iframe
        title="Property location"
        src={src}
        style={{ width: "100%", height, border: 0 }}
        loading="lazy"
      />
      <a
        href={`https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=18/${lat}/${lng}`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-1 bg-slate-900/90 px-2 py-1 text-[11px] font-medium text-white"
      >
        <MapPin className="h-3 w-3 text-accent" /> {Number(lat).toFixed(5)}, {Number(lng).toFixed(5)} — open in maps
      </a>
    </div>
  );
}
